<dx-select-box
  stylingMode="filled"
  [label]="label"
  [(value)]="value"
  [items]="items"
  [displayExpr]="displayExpr"
  [valueExpr]="valueExpr"
  [readOnly]="!isEditing"
  placeholder="{{ isEditing ? 'Select...' : '' }}"
  [elementAttr]="{ class: 'form-editor' }"
  [inputAttr]="{ class: 'form-editor-input' }"
  [showClearButton]="true"
  (onValueChanged)="valueChanged($event)"
>
  <dx-validator [validationRules]="validationRules()"></dx-validator>
</dx-select-box>
